<template>
  <div class="landing-wrap">
    <div class="landing-bg"></div>

    <div class="landing-scroll">
      <div class="landing-inner">
        <div class="landing-header">
          <h1 class="landing-title">Используемые в книге симуляторы</h1>
          <p class="landing-sub">В книге используются 4&nbsp;игры-симулятора: 1&nbsp;авторская игра и 3&nbsp;симулятора из открытого доступа. Каждый инструмент моделирует отдельный аспект принятия экономических решений.</p>
        </div>

        <section class="tools-panel" aria-label="Симуляторы">
          <div class="tools-grid">
            <a class="tool-card tool-card-author tool-card-link" :href="gameUrl">
              <span class="card-badge">авторская игра</span>
              <div class="card-main">
                <div class="card-title-block">
                  <div class="card-icon-wrapper" aria-hidden="true">
                    <img :src="chartSvg" class="card-icon-img" alt="">
                  </div>
                  <div class="card-title">Симулятор сделок</div>
                </div>
                <div class="card-desc">Авторский симулятор инвестиционного поведения позволяет принимать решения о покупке и продаже актива, анализировать рыночную динамику и оценивать результат выбранной стратегии в условиях неопределённости.</div>
              </div>
              <div class="card-url-row">
                <span class="external-icon" aria-hidden="true"></span>
                <span class="card-url">richkovinvest.com/invest-game</span>
              </div>
            </a>

            <div class="tool-card tool-card-fed">
              <span class="card-badge">открытый доступ</span>
              <div class="card-main">
                <div class="card-title-block">
                  <div class="card-icon-wrapper" aria-hidden="true">
                    <img :src="frsSvg" class="card-icon-img" alt="">
                  </div>
                  <div class="card-title">Federal Reserve Simulator</div>
                </div>
                <div class="card-desc">Симулятор деятельности ФРС позволяет работать с виртуальной консолью регулятора и моделировать решения в сфере денежно-кредитной политики. Пользователь управляет процентной ставкой и антикризисными мерами, наблюдая влияние на инфляцию, занятость, ВВП и финансовый рынок.</div>
              </div>
              <a class="card-url-row" href="https://www.federalreservesimulator.com" target="_blank" rel="noopener">
                <span class="external-icon" aria-hidden="true"></span>
                <span class="card-url">federalreservesimulator.com</span>
              </a>
            </div>

            <div class="tool-card tool-card-trust">
              <span class="card-badge">открытый доступ</span>
              <div class="card-main">
                <div class="card-title-block">
                  <div class="card-icon-wrapper" aria-hidden="true">
                    <img :src="peopleSvg" class="card-icon-img" alt="">
                  </div>
                  <div class="card-title">Эволюция доверия</div>
                </div>
                <div class="card-desc">Интерактивная модель, основанная на теории игр. Симулятор показывает, как разные стратегии поведения - сотрудничество, обман, взаимность и прощение - влияют на формирование доверия, репутации и устойчивой кооперации в экономической среде.</div>
              </div>
              <a class="card-url-row" href="https://notdotteam.github.io/trust/" target="_blank" rel="noopener">
                <span class="external-icon" aria-hidden="true"></span>
                <span class="card-url">notdotteam.github.io/trust/</span>
              </a>
            </div>

            <div class="tool-card tool-card-sanctions">
              <span class="card-badge">открытый доступ</span>
              <div class="card-main">
                <div class="card-title-block">
                  <div class="card-icon-wrapper" aria-hidden="true">
                    <img :src="globusSvg" class="card-icon-img" alt="">
                  </div>
                  <div class="card-title">Sanction Impact Dashboard</div>
                </div>
                <div class="card-desc">Интерактивная панель для моделирования санкционного шока позволяет оценить, как разрыв торговых связей влияет на страны, сектора и цепочки добавленной стоимости, выявляя уязвимости, возможные потери и асимметричное распределение экономических издержек.</div>
              </div>
              <a class="card-url-row" href="https://exposure.trade" target="_blank" rel="noopener">
                <span class="external-icon" aria-hidden="true"></span>
                <span class="card-url">exposure.trade</span>
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import chartSvg  from '@/assets/icons/chart.svg'
import frsSvg    from '@/assets/icons/frs.svg'
import peopleSvg from '@/assets/icons/people.svg'
import globusSvg from '@/assets/icons/globus.svg'

export default {
  name: 'LandingView',
  data() {
    return { chartSvg, frsSvg, peopleSvg, globusSvg }
  },
  computed: {
    gameUrl() {
      return process.env.VUE_APP_GAME_URL || '/invest-game/'
    }
  }
}
</script>

<style scoped>
.landing-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.landing-bg {
  position: absolute;
  inset: 0;
  background: url('../assets/icons/bg2.png') center / cover no-repeat;
  z-index: 0;
  pointer-events: none;
}

.landing-scroll {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.landing-inner {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: var(--space-65) var(--space-65) var(--space-20);
  box-sizing: border-box;
}

.landing-header {
  flex-shrink: 0;
  margin: 0 0 var(--space-18);
}

.landing-title {
  font-size: var(--fs-46);
  font-weight: 800;
  color: var(--color-navy);
  line-height: 1.08;
  letter-spacing: 0;
  margin: 0 0 var(--space-12);
  max-width: min(100%, 1260px);
}

.landing-sub {
  font-size: var(--fs-18);
  color: var(--color-muted);
  line-height: 1.45;
  margin: 0;
  max-width: min(100%, 1180px);
}

.tools-panel {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(0, 32, 96, 0.1);
  border-radius: var(--space-16);
  box-shadow: 0 12px 34px rgba(0, 32, 96, 0.18);
  padding: var(--space-24) var(--space-28);
  overflow: hidden;
}

.tools-grid {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
  gap: var(--space-14) var(--space-18);
}

.tool-card {
  --card-color: var(--color-primary);
  --card-bg: rgba(100, 169, 220, 0.09);
  --card-border: rgba(35, 86, 161, 0.28);
  --card-footer: rgba(100, 169, 220, 0.16);
  --icon-bg: var(--color-primary);

  position: relative;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: var(--card-color);
  background: var(--card-bg);
  border: 2px solid var(--card-border);
  border-radius: var(--space-12);
  box-shadow: var(--shadow-card-min);
  transition: box-shadow 0.12s, transform 0.12s;
}

.card-badge {
  position: absolute;
  top: var(--space-4);
  right: var(--space-10);
  font-size: var(--fs-13);
  font-style: italic;
  color: var(--color-muted);
  pointer-events: none;
}

.tool-card-link {
  color: inherit;
  text-decoration: none;
}

.tool-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(0, 32, 96, 0.1);
}

.tool-card-author {
  cursor: pointer;
  --card-grad: linear-gradient(to right, #2d5faa, transparent);
}

.tool-card-fed {
  --card-color: var(--color-market-blue);
  --card-bg: rgba(100, 169, 220, 0.08);
  --card-border: rgba(100, 169, 220, 0.34);
  --card-footer: rgba(100, 169, 220, 0.13);
  --icon-bg: var(--color-market-blue);
  --card-grad: var(--gradient-card-title-blue);
}

.tool-card-trust {
  --card-color: #6f923c;
  --card-bg: rgba(170, 197, 111, 0.09);
  --card-border: rgba(170, 197, 111, 0.5);
  --card-footer: rgba(170, 197, 111, 0.18);
  --icon-bg: var(--color-accent);
  --card-grad: var(--gradient-card-title-green);
}

.tool-card-sanctions {
  --card-color: #7d8491;
  --card-bg: rgba(185, 189, 199, 0.12);
  --card-border: rgba(185, 189, 199, 0.55);
  --card-footer: rgba(185, 189, 199, 0.22);
  --icon-bg: var(--color-market-gray);
  --card-grad: var(--gradient-card-title-gray);
}

.card-main {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  padding: var(--space-14) var(--space-12);
}

.card-title-block {
  display: flex;
  gap: 0;
  min-width: 0;
  align-items: stretch;
}

.card-icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--icon-bg);
  border-radius: var(--space-10);
  padding: var(--space-4) var(--space-8);
  flex-shrink: 0;
}

.card-icon-img {
  width: var(--space-44);
  height: var(--space-44);
  object-fit: contain;
}

.card-title {
  font-size: var(--fs-20);
  font-weight: 700;
  line-height: 1.2;
  color: var(--card-color);
  min-width: 0;
  display: flex;
  align-items: center;
  padding-left: var(--space-8);
  overflow-wrap: anywhere;
}

.card-desc {
  font-size: var(--fs-16);
  font-weight: 500;
  line-height: 1.45;
  color: var(--color-muted);
  padding-left: 0;
}

.card-url-row {
  min-height: var(--space-40);
  display: flex;
  align-items: center;
  gap: var(--space-14);
  padding: var(--space-8) var(--space-18);
  background: var(--card-footer);
  color: var(--card-color);
  text-decoration: none;
  border-top: 1px solid var(--card-border);
  font-size: var(--fs-15);
  font-weight: 800;
  line-height: 1.2;
}

.card-url-row:hover {
  filter: brightness(0.98);
}

.card-url {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.external-icon {
  width: var(--space-22);
  height: var(--space-22);
  background: linear-gradient(
    135deg,
    transparent 46%,
    currentColor 46%,
    currentColor 54%,
    transparent 54%
  ) right var(--space-5) top var(--space-5) / var(--space-10) var(--space-10) no-repeat;
  position: relative;
  flex-shrink: 0;
}

.external-icon::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: var(--space-14);
  height: var(--space-14);
  border: 2px solid currentColor;
  border-radius: var(--space-3);
}

.external-icon::after {
  content: "";
  position: absolute;
  right: var(--space-4);
  top: var(--space-4);
  width: var(--space-6);
  height: var(--space-6);
  border-top: 2px solid currentColor;
  border-right: 2px solid currentColor;
}

@media (max-width: 1100px) {
  .landing-header,
  .landing-title,
  .landing-sub { max-width: 100%; }
  .card-title { font-size: var(--fs-18); }
  .card-desc { font-size: var(--fs-16); }
  .card-url-row { font-size: var(--fs-13); }
}

@media (max-width: 700px) {
  .landing-wrap { overflow-y: auto; }
  .landing-scroll { overflow-y: auto; }
  .landing-inner {
    height: auto;
    min-height: 100%;
    padding: 22px 20px 28px;
  }
  .landing-header { margin-bottom: 16px; }
  .landing-title { font-size: 30px; line-height: 1.1; }
  .landing-sub { font-size: 16px; max-width: 100%; }
  .tools-panel {
    flex: none;
    min-height: 0;
    padding: 16px 14px 18px;
    border-radius: 14px;
  }
  .tools-grid {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
  .tool-card { min-height: 0; border-radius: 12px; }
  .card-main { padding: 22px 12px 12px; gap: 8px; }
  .card-icon-img { width: 32px; height: 32px; }
  .card-icon-wrapper { padding: 4px 6px; }
  .card-title { font-size: 16px; }
  .card-desc { font-size: 15px; line-height: 1.4; padding-left: 0; }
  .card-url-row { min-height: 42px; font-size: 14px; padding: 9px 14px; }
  .external-icon { width: 18px; height: 18px; }
  .card-badge { font-size: 13px; }
}

@media (max-width: 480px) {
  .landing-title { font-size: 26px; }
}
</style>
